enum PreferenceKeys {
    ACCESS_TOKEN = 'ACCESS_TOKEN',
    REFRESH_TOKEN = 'REFRESH_TOKEN',
}

class AppPreference {
    private setInStorage(key: PreferenceKeys, value: any): void {
        localStorage.setItem(key.toString(), value);
    }

    private getFromStorage(key: PreferenceKeys): any {
        return localStorage.getItem(key.toString());
    }

    private deleteFromStorage(key: PreferenceKeys): void {
        localStorage.removeItem(key.toString());
    }

    clearStorage(): void {
        localStorage.clear();
    }

    setObject(key: PreferenceKeys, object: any): void {
        const objectStr = JSON.stringify(object);
        this.setInStorage(key, objectStr);
    }

    getObject(key: PreferenceKeys): any {
        const objectStr = this.getFromStorage(key);
        if (objectStr) {
            return JSON.parse(objectStr);
        }
        return null;
    }

    clearToken(): void {
        this.deleteFromStorage(PreferenceKeys.ACCESS_TOKEN);
        this.deleteFromStorage(PreferenceKeys.REFRESH_TOKEN);
    }

    setAccessToken(accessToken: string): void {
        this.setInStorage(PreferenceKeys.ACCESS_TOKEN, accessToken);
    }

    getAccessToken(): string {
        return this.getFromStorage(PreferenceKeys.ACCESS_TOKEN);
    }

    setRefreshToken(refreshToken: string): void {
        this.setInStorage(PreferenceKeys.REFRESH_TOKEN, refreshToken);
    }

    getRefreshToken(): string {
        return this.getFromStorage(PreferenceKeys.REFRESH_TOKEN);
    }
}

export default new AppPreference();
